import { useRef } from "react";
import { AutoSizer, Grid } from "react-virtualized";

import { Box } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ImageCard from "./ImageCard";
import imageStore from "../../Mobx/Images";
import dictionary from "../../Mobx/Dictionary";
import { observer } from "mobx-react-lite";

const ImageList = ({ data, currentIndex, setSelectedWord, setOpen }) => {
    const gridRef = useRef(null);

    const scrollToCurrentIndex = () => {
        const cardWidth = imageStore.cardSize.width;
        const columnCount = Math.max(1, Math.floor(gridRef.current.props.width / (cardWidth + 1)));
        const rowIndex = Math.floor(currentIndex !== -1 ? currentIndex / columnCount : 0);
        gridRef.current.scrollToCell({
            columnIndex: 0, // אפשר גם לחשב לפי currentIndex % columnCount
            rowIndex,
        });
    };

    return (
        <Box sx={{ width: "100%", overflowX: "hidden", height: "100%", position: "relative" }}>

            <Tooltip title="גלול למיקום הנוכחי" arrow placement="right">
                <IconButton
                    onClick={scrollToCurrentIndex}
                    sx={{ position: "absolute", top: 3, left: 10, zIndex: 10 }}
                    color="primary"
                >
                    <MyLocationIcon />
                </IconButton>
            </Tooltip>

            <AutoSizer
                key={ // This is to force the list to re-render when the rowHeight changes or the dictionary type changes
                    dictionary.current.dictionaryType +
                    dictionary.current.sort?.field +
                    dictionary.current.sort?.order +
                    dictionary.dataChanged +
                    imageStore.cardSize.width +
                    imageStore.cardSize.height
                }
            >
                {({ width = 300, height = 500 }) => {
                    const cardWidth = imageStore.cardSize.width;
                    const cardHeight = imageStore.cardSize.height;

                    const columnCount = Math.max(1, Math.floor(width / (cardWidth + 1)));
                    const rowCount = Math.ceil(data.length / columnCount);

                    const cellRenderer = ({ columnIndex, rowIndex, key, style }) => {
                        const index = rowIndex * columnCount + columnIndex;
                        if (index >= data.length) return null;

                        const word = data[index];

                        return (
                            <div
                                key={key}
                                style={{
                                    ...style,
                                    padding: 4,
                                    boxSizing: "border-box",
                                }}
                            >
                                <ImageCard
                                    word={word}
                                    index={index}
                                    isSelected={index === currentIndex}
                                    onClick={() => {
                                        setSelectedWord(word);
                                        setOpen(true);
                                    }}
                                />
                            </div>
                        );
                    };

                    return (
                        <Grid
                            ref={gridRef}
                            columnCount={columnCount}
                            columnWidth={cardWidth}
                            height={height}
                            rowCount={rowCount}
                            rowHeight={cardHeight}
                            width={width}
                            cellRenderer={cellRenderer}
                            scrollToRow={Math.floor(currentIndex !== -1 ? currentIndex / columnCount : 0)}
                            scrollToAlignment="center"
                        />
                    );
                }}
            </AutoSizer>
        </Box>
    );
};

export default observer(ImageList);
